import { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { Sparkles, UserRound, Trees, Ruler, ArrowUpRight } from "lucide-react";
import { useI18n } from "@/i18n";
import { useAuth } from "@/context/AuthContext";
import { api, fileUrl } from "@/lib/api";
import { PageHeader, StatusBadge } from "@/components/common";

const TOOLS = [["hero", Sparkles], ["model", UserRound], ["lifestyle", Trees], ["dimensions", Ruler]];

export default function Overview() {
  const { t, fmtDate } = useI18n();
  const { user } = useAuth();
  const { ent } = useOutletContext();
  const [recent, setRecent] = useState([]);
  useEffect(() => {
    api.get("/projects", { params: { limit: 6 } }).then((r) => setRecent(r.data.items));
  }, []);
  return (
    <div data-testid="overview-page">
      <PageHeader title={t("app.welcome", { name: user?.name || "" })} sub={t("app.overviewSub")}>
        {ent && !ent.active && (
          <Link to="/app/subscription" className="btn-brand rounded-full px-4 py-2 text-sm font-semibold" data-testid="overview-subscribe-btn">{t("app.subscribeCta")}</Link>
        )}
      </PageHeader>
      <div className="grid sm:grid-cols-2 xl:grid-cols-4 gap-4">
        {TOOLS.map(([k, Icon], i) => (
          <Link key={k} to={`/app/${k}`} className="panel p-6 group hover:border-emerald-700/60 transition-colors fade-up" style={{ animationDelay: `${i * 60}ms` }} data-testid={`overview-tool-${k}`}>
            <div className="flex justify-between"><Icon className="text-emerald-400" size={22} /><ArrowUpRight size={18} className="text-neutral-600 group-hover:text-white transition-colors" /></div>
            <h3 className="mt-6 font-semibold text-lg">{t(`tools.${k}.name`)}</h3>
            <p className="text-sm text-neutral-400 mt-1">{t(`tools.${k}.desc`)}</p>
          </Link>
        ))}
      </div>
      <h2 className="text-lg font-semibold mt-12 mb-4">{t("app.recent")}</h2>
      {recent.length === 0 ? (
        <p className="text-neutral-500 text-sm" data-testid="overview-no-projects">{t("projects.empty")}</p>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
          {recent.map((p) => (
            <Link key={p.id} to={`/app/${p.tool}?project=${p.id}`} className="panel overflow-hidden hover:border-neutral-500 transition-colors" data-testid={`recent-project-${p.id}`}>
              <div className="aspect-square bg-white">
                <img loading="lazy" src={fileUrl(p.results?.[0]?.thumb_file_id || p.source_file_id)} alt={p.name} className="w-full h-full object-contain" />
              </div>
              <div className="p-2.5">
                <p className="text-xs font-medium truncate">{p.name}</p>
                <div className="flex items-center justify-between mt-1"><span className="text-[11px] text-neutral-500">{fmtDate(p.updated_at)}</span><StatusBadge status={p.status} /></div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
